import React from 'react'
import classNames from 'classnames'
import './Buttons.scss'

class Button extends React.Component {
  handleClick() {
    this.props.onClick()
  }
  render() {
    var buttonClass = classNames({
      btn: true,
      ['btn-' + this.props.addClass]: this.props.addClass,
    })
    return (
      <button onClick={e => this.handleClick(e)} className={buttonClass}>
        {this.props.children}
      </button>
    )
  }
}
class CloseButton extends React.Component {
  handleClick() {
    this.props.onClick()
  }
  render() {
    if (this.props.modal) {
      return (
        <button onClick={this.handleClick.bind(this)} className="btn-close">
          close
        </button>
      )
    } else {
      return null
    }
  }
}

class RadioButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: null,
    }
  }
  handleClick(e, index) {
    this.props.onChange({
      key: this.props.label,
      value: index + 1,
    })
  }
  render() {
    var groupClass = classNames({
      'radio-group': true,
      'cond-group': true,
      'btn-group': true,
      ['group_' + this.props.label]: true,
      ['col_' + this.props.col]: this.props.col,
    })
    // const activeClass =
    return (
      <div className={groupClass}>
        {this.props.options.map((d, i) => {
          return (
            <label
              key={i}
              index={i}
              value={this.props.value === i + 1}
              label={d}
              onClick={e => this.handleClick(e, i)}
              className={'radio-' + i}
            >
              <span
                className={classNames({
                  'radio-bullet': true,
                  active: this.props.value === i + 1,
                })}
              />
              <span className="label-text">
                {d.split('\n').map((str, index) => (
                  <React.Fragment key={index}>
                    {str}
                    <br />
                  </React.Fragment>
                ))}
              </span>
            </label>
          )
        })}
      </div>
    )
  }
}
class ButtonGroup extends React.Component {
  handleClick(index, is_toggle_on) {
    this.props.onChange({
      key: this.props.label,
      index: index,
      value: is_toggle_on,
    })
  }
  render() {
    var groupClass = classNames({
      'cond-group': true,
      'btn-group': true,
      ['group_' + this.props.label]: true,
      ['col_' + this.props.col]: this.props.col,
    })
    return (
      <div className={groupClass}>
        {this.props.options.map((d, i) => {
          return (
            <Toggle
              key={i}
              index={i}
              value={this.props.value[i]}
              label={d}
              onChangeToggle={this.handleClick.bind(this)}
            />
          )
        })}
      </div>
    )
  }
}
class ButtonGroupLimit extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      filled: false,
    }
  }
  handleClick(index, is_toggle_on) {

    this.props.onChange({
      key: this.props.label,
      index: index,
      value: is_toggle_on,
    })
  }
  render() {
    this.filled = this.props.value.filter(n => n).length >= 2
    var groupClass = classNames({
      'cond-group': true,
      'btn-group': true,
      ['group_' + this.props.label]: true,
      ['col_' + this.props.col]: this.props.col,
    })
    return (
      <div className={groupClass}>
        {this.props.options.map((d, i) => {
          return (
            <Toggle
              key={i}
              index={i}
              filled={this.filled}
              value={this.props.value[i]}
              label={d}
              onChangeToggle={this.handleClick.bind(this)}
            />
          )
        })}
      </div>
    )
  }
}

class Toggle extends React.Component {
  handleClick() {
    if (this.props.filled && !this.props.value) return
    this.props.onChangeToggle(this.props.index, !this.props.value)
  }
  // shouldComponentUpdate(nextProps) {
  //   return nextProps.value === this.props.value ? false : true
  // }
  render() {
    let className = 'btn-toggle'
    className += this.props.value ? ' active' : ''
    className += this.props.addClass ? ' ' + this.props.addClass : ''
    return (
      <button onClick={this.handleClick.bind(this)} className={`${className} ${!this.props.value && this.props.filled ? 'disabled' : ''}`}>
        <span>
          {this.props.label.split('\n').map((str, index) => (
            <React.Fragment key={index}>
              {str}
              <br />
            </React.Fragment>
          ))}
        </span>
      </button>
    )
  }
}
export default Toggle

export { Button, CloseButton, ButtonGroup, ButtonGroupLimit, RadioButton, Toggle }
